import React from 'react';
import {
  IconButton,
  Stack,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { RedLinkButton } from './styles';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useCopyToClipboard } from './useCopyToClipboard';
import { useCallback } from 'react';
import { useMatchMakingStore } from './store';

const NameIcon = styled('div')({
  width: '33px',
  height: '33px',
  borderRadius: '50px',
  paddingTop: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#E2001A',
  // backgroundColor: '#EC0E00',
  color: 'white',
  fontSize: '14px',
  fontFamily: 'Suisse-Intl',
  textTransform: 'uppercase',
});

const WhiteCard = ({ entity, handleReset, handleDelete, isReport }) => {
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).Common.whiteCard;
  const i18nAlerts = translations.MatchMakingV2(intl).Alerts;
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const { copy } = useCopyToClipboard();
  const closeAlert = (sev) =>
    useMatchMakingStore.setState({ alertData: { severity: sev } });

  const openAlert = ({ title, message = '', sev }) => {
    useMatchMakingStore.setState({
      alertData: {
        title,
        message,
        onClose: () => closeAlert(sev),
        severity: sev,
      },
    });
  };

  const onCopyToClipboard = useCallback(
    (text) => {
      if (text) {
        openAlert({ title: i18nAlerts.copy, sev: 'success' });
        copy(text);
      }
    },
    [copy]
  );

  const renderName = (str) => {
    const split = str.split(' ');
    if (split.length >= 2) {
      return `${split[0].charAt(0)}${split[1].charAt(0)}`;
    } else {
      return split[0].charAt(0);
    }
  };

  return (
    <Stack
      flexDirection={isMdDown ? 'column' : 'row'}
      gap={'15px'}
      padding={isMdDown ? '25px' : '20px'}
      justifyContent={'space-between'}
      sx={{ backgroundColor: 'white', border: '1px solid #E1E1E1' }}
    >
      <Stack
        flexDirection={isMdDown ? 'column' : 'row'}
        gap={isMdDown ? '15px' : '25px'}
        alignItems={isMdDown ? 'flex-start' : 'center'}
        sx={{
          ...(!isMdDown && {
            width: '33%',
          }),
        }}
      >
        <Stack
          width={'40px'}
          height={'40px'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <NameIcon>{renderName(entity.name)}</NameIcon>
        </Stack>
        <Typography
          variant="subheadling"
          sx={{
            whiteSpace: ' nowrap',
            overflow: ' hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {entity.name}
        </Typography>
      </Stack>
      <Stack
        flexDirection={'row'}
        justifyContent={isMdDown ? 'space-between' : 'flex-end'}
        alignItems={'center'}
        gap={isSmDown ? '0px' : isLgDown ? '5px' : '15px'}
        marginTop={isSmDown ? '-15px' : 'unset'}
        sx={{
          ...(!isMdDown && {
            width: '33%',
          }),
          ...(isLgDown && {
            paddingRight: '15px',
          }),
        }}
      >
        <Typography
          variant="calloutBig"
          color={theme.palette.grey[800]}
          sx={{
            whiteSpace: ' nowrap',
            overflow: ' hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {entity.email}
        </Typography>
        {!isReport ? (
          <IconButton onClick={() => onCopyToClipboard(entity.email)}>
            <ContentCopyRoundedIcon fontSize="small" color="primary" />
          </IconButton>
        ) : null}
      </Stack>
      <Stack
        flexDirection={'row'}
        gap={'25px'}
        alignItems={'center'}
        justifyContent={
          isMdDown ? (isSmDown ? 'space-between' : 'flex-start') : 'flex-end'
        }
        sx={{
          ...(!isMdDown && {
            width: '33%',
          }),
        }}
      >
        {!isReport ? (
          <>
            <RedLinkButton
              msg={i18n.reset}
              variant="link2"
              rightIcon={
                <ModeEditOutlineOutlinedIcon
                  fontSize="small"
                  htmlColor={theme.palette.primary.main}
                />
              }
              onClick={() => handleReset?.(entity.federationIdentifier)}
            />
            <RedLinkButton
              msg={i18n.delete}
              variant="link2"
              rightIcon={
                <DeleteOutlineOutlinedIcon
                  fontSize="small"
                  htmlColor={theme.palette.primary.main}
                />
              }
              onClick={() => handleDelete?.(entity.federationIdentifier)}
            />
          </>
        ) : (
          <>
            <Stack gap={'5px'} justifyContent={'center'} alignItems={'center'}>
              <Typography
                variant="s"
                textTransform={'uppercase'}
                color={theme.palette.grey[900]}
                textAlign={'center'}
              >
                {i18n.scansDay}
              </Typography>
              <Typography variant="body1-bold" textAlign={'center'}>
                {entity.todayMatchmaking || 0}
              </Typography>
            </Stack>
            <Stack gap={'5px'} justifyContent={'center'} alignItems={'center'}>
              <Typography
                variant="s"
                textTransform={'uppercase'}
                color={theme.palette.grey[900]}
                textAlign={'center'}
              >
                {i18n.totalScan}
              </Typography>
              <Typography variant="body1-bold" textAlign={'center'}>
                {entity.allMatchmaking || 0}
              </Typography>
            </Stack>
          </>
        )}
      </Stack>
    </Stack>
  );
};
export default WhiteCard;
